var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlutenFree = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Protein-Gluten-Wheat-Free--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Protein Gluten Wheat Free Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.70711 0.292893c-0.39053 -0.3905241 -1.023693 -0.3905241 -1.414217 0 -0.3905241 0.390524 -0.3905241 1.023687 0 1.414217L6.9693 8.38351l-0.45844 0.45026c-0.26832 2.05783 0.29343 4.20413 1.68727 5.89593l2.55867 -2.5587 1.0607 1.0607 -2.55872 2.5587c1.69242 1.3943 3.83952 1.9561 5.89802 1.6871l0.4492 -0.4572 6.6869 6.6868c0.3905 0.3905 1.0237 0.3905 1.4142 0 0.3905 -0.3905 0.3905 -1.0237 0 -1.4142l-6.6993 -6.6994 0.001 -0.0011 -0.5216 -0.5216 -0.0026 -0.0004 -2.5047 -2.5047c0.0018 0.0011 0.0037 0.0022 0.0056 0.0034l-0.7528 -0.7527 -0.001 0.001 -1.0607 -1.0606 0.0011 -0.0011 -0.7525 -0.7525c0.0011 0.0018 0.0023 0.0037 0.0034 0.0056L8.91824 7.50403l-0.00043 -0.00261 -0.52046 -0.52046 -0.00109 0.00108L1.70711 0.292893Z",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.8635 8.12496c-0.6803 -4.45047 2.2837 -7.414505 6.7342 -6.73417 0.6803 4.45046 -2.2837 7.4145 -6.7342 6.73417Z",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.36693 21.2126 2.16898 -2.169c-1.73846 -2.4163 -1.50607 -5.8088 0.6872 -7.9629l0.73739 -0.7243c0.10925 1.9456 0.83297 3.8635 2.17278 5.4382L5.5648 17.3631c-0.29289 0.2929 -0.29289 0.7677 0.00001 1.0606 0.29289 0.2929 0.76777 0.2929 1.06066 0l1.56846 -1.5685c1.575 1.3402 3.49337 2.064 5.43937 2.173l-0.7256 0.7385c-2.1526 2.191 -5.54113 2.4244 -7.95681 0.6904l-2.16975 2.1697c-0.39052 0.3906 -1.02369 0.3906 -1.41421 0 -0.390525 -0.3905 -0.390525 -1.0237 0 -1.4142Z",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.1906 13.6528 -2.8972 -2.8971 1.4942 -1.49424c0.1395 -0.03281 0.2805 -0.06209 0.4228 -0.08747 1.6738 -0.2987 3.5908 -0.06769 5.0805 1.42201 0.175 0.1751 0.1763 0.4585 0.0028 0.6351l-2.3663 2.4085c-0.5765 0.0695 -1.1594 0.0739 -1.7368 0.0132Z",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.2327 9.69503 -2.8969 -2.89694c-0.0605 -0.57634 -0.0562 -1.15814 0.0128 -1.73358l2.4087 -2.36567c0.1766 -0.17346 0.4601 -0.17218 0.6351 0.00287 1.4897 1.48967 1.7208 3.40559 1.422 5.07848 -0.0252 0.1413 -0.0543 0.28143 -0.0869 0.42003l-1.4948 1.49481Z",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlutenFree);
export default ForwardRef;